import React, {forwardRef, useEffect, useImperativeHandle, useState} from 'react';
import {useGlobalNotificationMessage} from "../context/message";
import HelperService from "../services/helper-service";
import {useHomepageService} from "../services/homepage-service";
import Loading from "./loading";
import Section from "./section";
import {Modal} from "react-bootstrap";
import {AppRoutes} from "../utils/constants";
import {Link} from "react-router-dom";
import StarRating from "./star-rating";
import {useFavouritesService} from "../services/favourites-service";
import {useAuth} from "../context/auth";


const TopTrainersListModal = forwardRef( ({trainersList=null, callback=null, ...props}, ref) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [trainers, setTrainers] = useState([]);
  const {addErrorMessage } = useGlobalNotificationMessage();

  const homepageService = useHomepageService();
  const favouriteService = useFavouritesService();
  const auth = useAuth();

  //expose api for interacting with component
  useImperativeHandle(ref, () => ({
    openModal: openModal,
    closeModal: closeModal,
  }));

  const openModal = () => {
    if (trainersList){
      setTrainers([...trainersList]);
    } else {
      setLoading(true);

      let promises = [
        homepageService.getTopTrainers()
      ];

      Promise.all(promises).then(([_trainersList])=>{
        setTrainers([..._trainersList]);
        setLoading(false);
      });
    }

    setShow(true);
  }

  useEffect(() => {
    setTrainers([...trainersList]);
  }, [trainersList]);

  const closeModal = () => setShow(false);

  const toggleLikeTrainer = function (t){
    if (t.liked){
      favouriteService
          .unlikeTrainer(t.id)
          .then(() => {
            if ('function'===typeof callback){
              let newT = Object.assign({}, t, {liked:false});
              callback(newT);
            }
          })
          .catch(error => {
            HelperService.handleApiErrors(error, addErrorMessage);
          });
    } else {
      favouriteService
          .likeTrainers([t.id])
          .then(() => {
            if ('function'===typeof callback){
              let newT = Object.assign({}, t, {liked:true});
              callback(newT);
            }
          })
          .catch(error => {
            HelperService.handleApiErrors(error, addErrorMessage);
          });
    }
  }

  const TopTrainerModalCell = function({trainer, ...props}) {
    return (
        <Link to={`${AppRoutes.trainers.path}/${trainer.id}`} className="clickable router-link">
          <div className="card px-3 py-4 mb-4 border-0 hover-cell-effect rounded-3">
            <div className="d-flex flex-row gap-3">
              <div className="rounded-circle bg-cover flex-shrink-0"
                   style={{backgroundImage: `url(${trainer.photo})`, width: '90px', height: '90px'}}></div>
              <div className="px-2 w-100" style={{minWidth: 0}}>
                <h6 className="mb-1">{trainer.name} {trainer.surname}</h6>
                <div className="text-secondary fs-7 mb-1">
                  {trainer.classes === 0 && <span>No upcoming events</span>}
                  {trainer.classes > 0 && <span>Upcoming {trainer.classes} events</span>}
                </div>
                <StarRating rating={trainer.rating} count={trainer.ratingsCount} showCount={true} />
                {trainer.id!==auth.currentUser.id && <button
                    onClick={(e)=>{e.preventDefault(); toggleLikeTrainer(trainer);}}
                    className={`btn btn-sm mt-2 ${trainer.liked ? 'btn-outline-primary' : 'btn-primary'}`}>
                  {trainer.liked ? 'Following' : 'Follow'}
                </button>}
              </div>
            </div>
          </div>
        </Link>
    );
  }

  return (
      <>
        <Modal size='xl' show={!!show} onHide={closeModal} centered>
          <Modal.Header closeButton>
            <h4 className="header-stripe-blue col-sm-6 pb-1">Top FitPros</h4>
          </Modal.Header>
          <Modal.Body className="p-5">
            <Section animation={HelperService.getRandomAnimation()}>
              <div className="row">

                {loading && <Loading />}
                {!loading && <>
                  {trainers?.length===0 && <div className="col-sm-12"><p>There are no Top trainers defined. They will appear
                    here as soon as we find some!</p></div>}
                  {trainers?.length>0 && <>
                    {trainers.map(t=><div className="col-sm-12 col-md-6" key={t.id}><TopTrainerModalCell trainer={t} /></div>)}
                  </>}
                </>}

              </div>
            </Section>
          </Modal.Body>
        </Modal>
      </>
  );
});

export default TopTrainersListModal;
